import { Component, Input, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
	selector: 'app-cig-the-4-stages',
	templateUrl: './cig-the-4-stages.component.html',
	styleUrls: ['./cig-the-4-stages.component.scss']
})
export class CigThe4StagesComponent implements OnInit {

	@Input() foursightassets;
	@Input() author;
	@Input() slides;
	public env;

	constructor() { }

	ngOnInit() {
		this.env=environment;
	}

}
